import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import { PipelineResponseSchema } from "@applicant-reviewer/api";

export function usePipeline(status?: string) {
  const path = status ? `/pipeline?status=${encodeURIComponent(status)}` : "/pipeline";

  return useQuery({
    queryKey: queryKeys.pipeline.list(status),
    queryFn: () => apiClient.get(path, PipelineResponseSchema),
  });
}
